<!-- 印章 -->
<template>
  <div :class="['teas-seal', 'mobile', 'teas-seal-' + status, 'teas-seal-' + size]">
    <div class="teas-seal-text">{{ text }}</div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasSeal",
  ctrlCaption: "印章",
  mixins: [$mixins.control],
  design: {},
  props: {
    // 文字
    text: {
      type: String,
      default: "通过",
    },
    // 状态
    // primary-蓝色 success-绿-成功/通过 warning-黄-警告 danger-红-失败/未通过
    status: {
      type: String,
      default: "primary",
    },
    // 大小
    // large-大 medium-中 small-小
    size: {
      type: String,
      default: "medium",
    },
  },
  data() {
    return {
      aaa: "",
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {},
});
</script>
